import api from './services/mkm.api.js'

const resource = '/wettbewerb'

export default {
    senden(payload) {
        return api.post(`${resource}/teilnahme`, payload)
    },
    alle() {
        return api.get(`${resource}`)
    },
    get(id){
        return {
            info: function () {
                return api.get(`${resource}/${id}`)
            },
            faecher: function () {
                return api.get(`${resource}/${id}/faecher`)
            },
            altersgruppen: function(typ){
                return api.get(`${resource}/${id}/altersgruppen/${typ}`)
            }
        }
    },
}